import {
  IFreezeRequestsTableReport,
  IFreezeTablesProps,
  IFreezeTablesSearchParams,
} from "../../Interfaces/freeze";
import TableTemplate from "../TableTemplate/tableTemplate";
import { CommonTableUI } from "../TableTemplate/common";
import { getFreezeRequestsTable } from "../../Requests/freeze";

const FreezeRequests = ({ searchParam }: IFreezeTablesProps) => {
  return (
    <TableTemplate<IFreezeTablesSearchParams, IFreezeRequestsTableReport>
      refreshTableTime={5000}
      getDataTable={(searchParam, offset, pageSize, sortingType) =>
        getFreezeRequestsTable(searchParam, offset, pageSize, sortingType || "")
      }
      withSort
      TableUI={({ reports, onAction, sortingType, setSortingType }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          setSortingType={setSortingType}
          sortingType={sortingType}
        />
      )}
      searchParameters={searchParam}
    />
  );
};

export default FreezeRequests;
